import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues5, KeyValueSet, LocalService, ProductColumnKey, ProductLogDetailsInitialization } from '../../../service/local.service';
import { ProductManagementService } from '../../../service/product-management.service';

@Component({
  selector: 'app-product-log-details',
  templateUrl: './product-log-details.component.html',
  styleUrls: ['./product-log-details.component.scss']
})
export class ProductLogDetailsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["product_log"]; ctryCode: string = '';
  logId: string = ''; interactionType = 0; userId: string = ''; iCurrentRow = 1; iTotalCount = 0;
  source: ProductLogDetailsInitialization; maxBodyHeight = 0; selectedProductLogStatus = '0';
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private productManagementService: ProductManagementService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.logId = routeParams.logId;
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.onLoad();
    });
  }

  onLoad() {
    this.productManagementService.getProductLogDetailsInitialization(this.logId, this.ctryCode).subscribe(result => {
      this.source = result;
      this.onSetTotalCount();
    });
  }

  onSetTotalCount() {
    this.iTotalCount = parseInt(this.source.statusSummary.find(x => x.key == this.selectedProductLogStatus).value);
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onGetText(index, key, detailLine: KeyValues5 = null) {
    let item: KeyValueSet;
    let differenceText = '';
    switch (index) {
      case 1: {
        item = this.source.productLogStatus.find(x => x.key == key);
      } break;
      case 2: {
        let productColumnKey: ProductColumnKey = parseInt(detailLine.key);
        if (productColumnKey == ProductColumnKey.Tax) {
          item = this.source.taxes.find(x => x.key == detailLine.v4);
        } else {
          item = this.source.productColumnKey.find(x => x.key == detailLine.key);
        }

        switch (productColumnKey) {
          case ProductColumnKey.ProductName: {
            differenceText = this.localService.getEquivalentTitle(detailLine.v3);
          } break;
          //case ProductColumnKey.MinimumQuantity:
          //case ProductColumnKey.Tax:
          case ProductColumnKey.Price: {
            differenceText = this.source.businessTypes.find(x => x.key == detailLine.v3).value;
          } break;
        }
      } break;
      case 3: {
        item = this.source.productLogReason.find(x => x.key == detailLine.v2);
      } break;
    }
    return (item ? item.value : '') + (differenceText != '' ? " (" + differenceText + ") " : '');
  }

  onStatusSelect() {
    this.iCurrentRow = 1;
    this.onSetTotalCount();
    this.onGetLogDetail();
  }

  onGetLogDetail(index = 0) {
    switch (index) {
      case 1: {
        this.iCurrentRow = this.iCurrentRow - 1;
      } break;
      case 2: {
        this.iCurrentRow = this.iCurrentRow + 1;
      } break;
    }
    this.productManagementService.getProductLogDetails(this.logId, this.iCurrentRow, parseInt(this.selectedProductLogStatus), this.ctryCode).subscribe(result => {
      this.source.details = result;
    });
  }
}
